import { ConfigProvider as BrandConfigProvider } from "antd";
import { ABSTRACT_BACKGROUND, BRAND_THEME } from "../../../../libs/constants";
import React, { useContext, useEffect, useState } from "react";
import * as Yup from "yup";

import { Box, Grid, Paper, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAllClientsNoPagination,
  workflowTruckById,
  workflowTruckPost,
  workflowTruckPut,
} from "../../../../libs/apis";
import { useSnackbar } from "@components";
import {
  Button as ButtonAntd,
  Popconfirm,
  ConfigProvider,
  Segmented,
  Space,
  Progress,
} from "antd";
import { CheckCircleFilled, ClearOutlined } from "@ant-design/icons";
import { useWorkflowTruckStore } from "../../store";
import { ClientI } from "../../../../libs/interfaces";
import { SecondComponent } from "./second-component/page";
import { FirstComponent } from "./first-component";
import { useWidth } from "../../../../libs/hooks";
import { COLOR_PRIMARY, COLOR_SECONDARY } from "../../../../libs/constants";
import { NAVBAR_HEIGHT_SUM } from "../../../../libs/constants";
import { css } from "@emotion/css";
import { DateFormatHelper } from "../../../../libs/helpers";
import { useRouterStore } from "../../../../libs/stores";
import Swal from "sweetalert2";

const WorkflowAddComponent = () => {
  const width = useWidth();

  return (
    <BrandConfigProvider theme={BRAND_THEME}>
    <Grid
      container
      spacing={0.5}
      justifyContent="center"
      sx={{
        mt: 0,
        maxHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        minHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        height: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        overflowY: "hidden",
        overflowX: "hidden",
        ...ABSTRACT_BACKGROUND,
      }}
    >
      <Grid item xs={12} md={6}>
        <Paper elevation={2} sx={{ m: width === "xs" ? 0 : 1 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Component width={width} />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
    </BrandConfigProvider>
  );
};

interface ComponentPropsI {
  width: string;
}
const Component = ({ width }: ComponentPropsI) => {
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const setSection = useRouterStore((state) => state.setSection);
  const [clients, setClients] = useState<ClientI[]>([]);
  const step = useWorkflowTruckStore((state) => state.step);
  const setDataTruck = useWorkflowTruckStore((state) => state.setDataTruck);
  const onClear = useWorkflowTruckStore((state) => state.onClear);

  useEffect(() => {
    setSection("Camión 🚛");
    handleGetData();
    return () => {
      setSection("");
      if (id) onClear();
    };
  }, []);

  const handleGetData = async () => {
    try {
      if (id) {
        const { data: dataWf } = await workflowTruckById(Number(id));
        if (!dataWf) return;

        setDataTruck(dataWf);
      }

      const { data: dataClients } = await getAllClientsNoPagination();
      if (!dataClients) return;
      setClients(dataClients);
    } catch (err) {
      console.log(err);
      enqueueSnackbar(err!.toString(), { variant: "error" });
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        overflowY: "hidden",
        overflowX: "hidden",
      }}
    >
      {/* <ProgressComponent /> */}
      <HeaderComponent width={width} id={id} enqueueSnackbar={enqueueSnackbar} />

      {step === "Formulario" ? (
        <FirstComponent clients={clients} width={width} />
      ) : (
        <SecondComponent />
      )}
    </Box>
  );
};

interface HeaderPropsI {
  width: string;
  id: string | undefined;
  enqueueSnackbar: (message: string, options?: any) => void;
}

const HeaderComponent = ({ width, id, enqueueSnackbar }: HeaderPropsI) => {
  const navigate = useNavigate();
  const { getPrefixCls } = useContext(ConfigProvider.ConfigContext);
  const rootPrefixCls = getPrefixCls();
  const [isProcessing, setProcessing] = useState(false);

  const onClear = useWorkflowTruckStore((state) => state.onClear);
  const resetSteps = useWorkflowTruckStore((state) => state.resetSteps);

  const validationSchema = Yup.object({
    container: Yup.string().required("N° Contenedor Requerido"),
    clientId: Yup.string().required("Exportador Requerido"),
    producerId: Yup.string().required("Productor Requerido"),
    farmId: Yup.string().required("Hacienda Requerida"),
    magap: Yup.string().required("Magap Requerido"),
    boxId: Yup.string().required("Tipo de Caja Requerido"),
    brandId: Yup.string().required("Marca Requerido"),
    startProcess: Yup.string().required("Inicio de Proceso Requerido"),
    closeProcess: Yup.string().required("Cierre de Proceso Requerido"),
    endLoading: Yup.string().required("Fin de Carga Requerido"),
    containerClose: Yup.string().required("Cierre de Camión Requerido"),
    numCajas: Yup.number().required("N° Cajas Requerido"),
    driver: Yup.string().required("Conductor Requerido"),
    placa: Yup.string().required("Placa Requerido"),
    companyTransport: Yup.string().required("Compañía Requerido"),
    calidad: Yup.string().required("Calidad Requerido"),
    calidadCi: Yup.string().required("Cédula Requerido"),
    gancho: Yup.string().required("Gancho Requerido"),
    ganchoCi: Yup.string().required("Cédula Requerido"),
    photo1: Yup.string().required("Foto Cajas requerida"),
    photo2: Yup.string().required("Foto Camión requerida"),
    photo3: Yup.string().required("Foto Cierre Camión requerida"),
    photo4: Yup.string().required("Foto Sello 1 requerida"),
    photo5: Yup.string().required("Foto Sello 2 requerida"),
    photo6: Yup.string().required("Foto Tarja de Carga requerida"),
    photo7: Yup.string().required("Foto Guía de Transporte requerida"),
    photo8: Yup.string().required("Foto Evaluación de Fruta requerida"), 
  });

  const getDataTruck = useWorkflowTruckStore(
    (state) => state.getDataTruck
  );

  const linearGradientButton = css`
    &.${rootPrefixCls}-btn-primary:not([disabled]):not(
        .${rootPrefixCls}-btn-dangerous
      ) {
      border-width: 0;

      > span {
        position: relative;
      }

      &::before {
        content: "";
        background: linear-gradient(135deg, ${COLOR_PRIMARY}, ${COLOR_SECONDARY});
        position: absolute;
        inset: 0;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `;

  const handleSave = async () => {
    try {
      const dateFormat = new DateFormatHelper();
      setProcessing(true);
      await validationSchema.validate(getDataTruck());

      if (id) {
        const { data: dataPut } = await workflowTruckPut(
          Number(id),
          getDataTruck()
        );
        if (!dataPut) return;
        enqueueSnackbar(dataPut, { variant: "info" });
      } else {
        const objPost = {
          ...getDataTruck(),
          containerOulet: dateFormat.getTime(),
        };
        const { data: dataPost } = await workflowTruckPost(objPost);
        if (!dataPost) return;
        enqueueSnackbar(dataPost.alert, {
          variant: dataPost.variant ? dataPost.variant : "success",
        });
      }

      resetSteps();
      // onClear();
      navigate("/truck/list");

      setProcessing(false);
    } catch (err: any) {
      setProcessing(false);
      enqueueSnackbar(err.toString(), { variant: "error" });
    }
  };

  const handleResetWithFear = () => {
    Swal.fire({
      title: "¡Atención!",
      html: `<p style="font-weight:bolder; color:red">Estás a punto de BORRAR todo. <br/> ¿Estás seguro?</p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar todo",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Aquí sí ejecutas el borrado real
        onClear();
        resetSteps();
        Swal.fire({
          title: "¡Listo!",
          text: "Toda la información fue borrada",
          icon: "success",
        });
      }
    });
  };

  return (
    <Box
      sx={{
        position: "absolute",
        top: width === "xs" ? -7 : -8,
        width: "100%",
        height: 50,
        bgcolor: "white",
        zIndex: 701,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        alignContent: "center",
        p: 0.5,
        borderBottom: "1px dashed gainsboro",
      }}
    >
      <StepComponent />
      <Box>
        <ConfigProvider
          button={{
            className: linearGradientButton,
          }}
        >
          <Space size="small">
          <Popconfirm
              title="Se borrará toda la Información"
              description="Desea Continuar?"
              onConfirm={handleResetWithFear}
              zIndex={1601}
              okText="Si"
              cancelText="No"
            >
              <ButtonAntd
                size="middle"
                type="primary"
                danger
                icon={<ClearOutlined />}
              />
            </Popconfirm>
            <Popconfirm
              title="Finalizar Proceso"
              description="Si Finaliza no podrá editar la Información"
              onConfirm={handleSave}
              okText="Si"
              cancelText="No"
              icon={<CheckCircleFilled />}
              zIndex={1601}
            >
              <ButtonAntd
                size="middle"
                loading={isProcessing}
                type="primary"
                icon={<CheckCircleFilled />}
                disabled={isProcessing}
              >
                Finalizar
              </ButtonAntd>
            </Popconfirm>
          
          </Space>
        </ConfigProvider>
      </Box>
    </Box>
  );
};

const StepComponent = () => {
  const step = useWorkflowTruckStore((state) => state.step);
  const setStep = useWorkflowTruckStore((state) => state.setStep);

  return (
    <Segmented
      options={["Formulario", "Fotos"]}
      value={step}
      onChange={setStep}
    />
  );
};

const ProgressComponent = () => {

  const statusT = useWorkflowTruckStore((state) => state.statusT);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 45,
        right: 1,
        width: "99.99%",
        zIndex: 700,
      }}
    >
      <Progress
        percent={statusT}
        status="success"
        showInfo={false}
        trailColor="white"
        strokeLinecap="butt"
      />
    </Box>
  );
};

export default WorkflowAddComponent;
